import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { coreOrganizationsLinkPostAsyncSlice } from './post';

export const coreOrganizationsLinkReducers = combineReducers({
	post: coreOrganizationsLinkPostAsyncSlice.asyncReducers
});

export const coreOrganizationsLinkWatchers = combineAllWatchers([
	coreOrganizationsLinkPostAsyncSlice.asyncWatchers
]);
